import { h, Component } from 'preact'
import { connect } from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import constants, {priceColumns} from '../constants'
import util from '../util';
import MenuObject from "../canvas/menu-object";
import { BorderOuterOutlined, DownOutlined } from '@ant-design/icons';
import { Switch } from 'antd';

export default @connect(reduce, actions)
class MenuObjectBorderWidget extends Component {
  constructor() {
    super();

    this.getBorderCss = () => {
      const $element = this.props.$element;
      if (!$element) return;
      return util.getMOBorderColor($element);
    }

    this.getFillCss = () => {
      const $element = this.props.$element;
      if (!$element) return;
      if ($element.attr('data-color')) {
        return util.getCssFromColorData($element.attr('data-color'));
      } else {
        let styles = MenuObject.getStyles($element);
        if (styles && styles.items && styles.items.backgroundColor) {
          return styles.items.backgroundColor;
        } else {
          return '#fff';
        }
      }
    }

    this.updatePriceBorder = (priceBorderOn, priceBorderDouble) => {
      const $element = this.props.$element;
      const priceBorderVal = !priceBorderOn ? 'none' : priceBorderDouble ? 'double' : 'single';
      this.props.updateElementAttribute('priceBorder', priceBorderVal);
      $element.attr('data-price-border', priceBorderVal);
      MenuObject.updatePriceBorder($element, priceBorderOn, priceBorderDouble);
    }

    this.applyToAll = (type) => {
          const $element = this.props.$element;
          if (!$element) return;
          if (type === 'border') {
            window.ConfirmationModal.show({
              title: 'Are you sure?',
              body: 'This will apply the current menu object border settings to the entire menu.',
              acceptLabel: 'Yes, apply to all',
              declineLabel: 'Cancel',
              onAccept: () => {
                MenuObject.applyToAll($element, MenuObject.applyModes.border);
              },
              onDecline: () => {
                window.ConfirmationModal.hide()
              }
            });
          } else if (type === 'fill') {
            window.ConfirmationModal.show({
              title: 'Are you sure?',
              body: 'This will apply the current menu object fill settings to the entire menu.',
              acceptLabel: 'Yes, apply to all',
              declineLabel: 'Cancel',
              onAccept: () => {
                MenuObject.applyToAll($element, MenuObject.applyModes.fill);
              },
              onDecline: () => {
                window.ConfirmationModal.hide()
              }
            });
          } else if (type === 'price-border') {
            window.ConfirmationModal.show({
              title: 'Are you sure?',
              body: 'This will apply the current price border settings to the entire menu.',
              acceptLabel: 'Yes, apply to all',
              declineLabel: 'Cancel',
              onAccept: () => {
                MenuObject.applyToAll($element, MenuObject.applyModes.priceBorder);
              },
              onDecline: () => {
                window.ConfirmationModal.hide()
              }
            });
          }
        }
    
  };

  render(props, state) {
    const isPriceColumnLayout = this.props.$element ? priceColumns.includes(this.props.$element.attr('data-layout')) : false;
    return (
      <div className="dropdown">
        {!props.isMobileVersion && <a className="dropdown-toggle icn rwd-icon">Border</a>}
        {props.isMobileVersion && <a className="dropdown-toggle mobile-tool-widget">
          <BorderOuterOutlined/>
          <span>Border</span>
        </a>}

        <div className="dropdown-menu border-mo" data-close="no">
          {props.isMobileVersion && <div className="mobile-dropdown-header">
            <span>Border</span>
            <div className="dropdown-toggle"><DownOutlined/></div>
          </div>}
          <div className={'position-header'}>Border</div>
          <div className={'apply-to-all btn secondary1'} onClick={() => this.applyToAll('border')}>Apply to all</div>
          <ul className="slider-list">
            <li className="color-item">
              <div className="border-color">
                <label>Color</label>
                <div onClick={() => this.props.openColorPicker(constants.pickerTypes.moBorder)}>
                  <span className="color-box" style={`background: ${this.getBorderCss()}; float: none;`}></span>
                </div>
              </div>
            </li>
            <li className="slider-item">
              <div className={'slider-wrap'}>
                <label>Width</label>
                <div className="toolbar-wrap">
                  <input className="slider" type="range" min="0" max="25" step="1" value={props.borderWidth} onChange={props.onWidthUpdate} onMouseMove={props.onWidthUpdate} />
                </div>
                <input className="value" type="number" min="0" max="25" step="1" disabled="disabled" value={props.borderWidth} />
              </div>
            </li>
            <li className="slider-item border-radius">
              <div className={'slider-wrap'}>
                <label>Radius</label>
                <div className="toolbar-wrap">
                  <input className="slider" type="range" min="0" max="100" step="1" value={props.value} onChange={props.onUpdate} onMouseMove={props.onUpdate} />
                </div>
                <input className="value" type="number" min="0" max="100" step="1" disabled="disabled" value={props.value} />
              </div>
            </li>
          </ul>
          <div className={'position-header  margin-top'}>Fill</div>
          <div className={'apply-to-all fill-apply btn secondary1'} onClick={() => this.applyToAll('fill')}>Apply to all</div>
          <ul className="slider-list">
            <li className="color-item">
              <div className="border-color fill">
                <label>Color</label>
                <div onClick={() => this.props.openColorPicker(constants.pickerTypes.moFill)}>
                  <span className="color-box" style={`background: ${this.getFillCss()}; float: none;`}></span>
                </div>
              </div>
            </li>

            <li className="slider-item">
              <div className={'slider-wrap'}>
                <label>Opacity</label>
                <div className="toolbar-wrap">
                  <input className="slider" type="range" min="0" max="100" step="1" value={this.props.backgroundColorOpacity} onChange={props.onOpacityUpdate} onMouseMove={props.onOpacityUpdate} />
                </div>
                <input className="value" type="number" min="0" max="100" step="1" disabled="disabled" value={Math.round(this.props.backgroundColorOpacity)} />
              </div>
            </li>
          </ul>

          {isPriceColumnLayout &&
          <div className={'position-header margin-top'}>Price Border <Switch checked={this.props.priceBorder === 'single' || this.props.priceBorder === 'double'} onChange={(val) => this.updatePriceBorder(val, false)}/></div>}
          {isPriceColumnLayout &&
          <div className={'apply-to-all price-border-apply btn secondary1'} onClick={() => this.applyToAll('price-border')}>Apply to all</div>}
          {isPriceColumnLayout &&
          <ul className={`price-border-options ${this.props.priceBorder === 'none' ? 'disabled' : ''}`}>
            <li className={this.props.priceBorder === 'single' ? 'active' : ''} onClick={() => this.updatePriceBorder(true, false)}>
              <div className='single-border'/>
            </li>
            <li className={this.props.priceBorder === 'double' ? 'active' : ''} onClick={() => this.updatePriceBorder(true, true)}>
              <div className='double-border'/>
            </li>
          </ul>}
        </div>
      </div>);
  };
}
